'use client';

import React from 'react';
import { useTranslation } from '@/i18n/useTranslation';

export default function CoreProductBanner() {
  const { t } = useTranslation();
  return (
    <section className="landing-identity-strip py-8">
      <div className="mx-auto max-w-screen-2xl px-6 text-center lg:px-10 2xl:px-16">
        <p className="mx-auto max-w-3xl text-base font-semibold leading-relaxed text-[var(--public-emerald-deep)] sm:text-lg">
          {t('landing_trust_clarifier.subtitle' as any)}
        </p>
        <div className="mx-auto mt-5 flex max-w-4xl flex-wrap items-center justify-center gap-2 text-xs font-bold text-slate-600">
          {(
            [
              t('landing_trust_clarifier.chip_preserved' as any),
              t('landing_trust_clarifier.chip_proof' as any),
              t('landing_trust_clarifier.chip_certs' as any),
              t('landing_trust_clarifier.chip_private' as any),
            ] as string[]
          ).map((line) => (
            <span key={line} className="landing-identity-chip rounded-full px-3 py-1.5">
              {line}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
